// extracted by mini-css-extract-plugin
module.exports = {"topLine":"StickyPricingTextWrapper_topLine__cPx67"};